/**
 * Store Résultats Statuts
 */
export default {
    state: {
        resultatStatuts: [],
        statutACompleter: 1,
        statutComplete: 2,
        statutSupervise: 3,
    },

    mutations: {
        /**
         * Initialise le state resultatStatuts
         */
        setResultatStatuts: function (state, resultatStatuts) {
            state.resultatStatuts = resultatStatuts
        }
    },

    actions: {
        /**
         * Initialise le state resultatStatuts
         */
        initResultatStatuts: function (context) {
            if (context.state.resultatStatuts.length === 0) {
                axios.get('/api/resultat-statuts').then(response => {
                    context.commit('setResultatStatuts', response.data.data)
                })
            }
        }
    },

    getters: {
        /**
         * Liste d'options de statuts de résultats
         */
        optionsResultatStatuts: state => {
            return state.resultatStatuts.map(statut => {
                return {label: statut.nom, value: statut.id}
            })
        },
    }
}
